import React, { useContext } from "react";

import { IntlContext } from "context";
import ComponentList from "app/OurService/List/ComponentList";
import CardSkeleton from "app/OurService/List/CardSkeleton";
import { fetchOurServices } from "hooks/service";
import { usePreviewList } from "hooks/usePreviewList";
import type { OurServiceInterface } from "types/service";

const PREVIEW_COUNT = 6;

const SUBCATEGORY_PROVIDERS_GRID_CLASS = "grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3";

interface SubCategoryProvidersContentProps {
    queryKey: string;
    fetcherParams: HashMap<unknown>;
    title: string;
    categoryLabel: string;
    noResultsLabel?: string;
}

const SubCategoryProvidersContent: React.FC<SubCategoryProvidersContentProps> = ({
    queryKey,
    fetcherParams,
    title,
    categoryLabel,
    noResultsLabel,
}) => {
    const intl = useContext(IntlContext);
    const { data, isLoading } = usePreviewList(fetchOurServices, fetcherParams, queryKey);
    const items = [...(data ?? [])] as OurServiceInterface[];

    const subtitle = intl.formatMessage("subcategoryPage.providers_subtitle", {
        count: items.length,
        category: categoryLabel,
    });

    return (
        <>
            <header className="mb-8 space-y-2">
                <h2 className="text-3xl font-black tracking-tight text-foreground sm:text-4xl">{title}</h2>
                {!isLoading && items.length > 0 && <p className="text-sm text-muted-foreground">{subtitle}</p>}
            </header>

            {isLoading ? (
                <div className={SUBCATEGORY_PROVIDERS_GRID_CLASS}>
                    {Array.from({ length: PREVIEW_COUNT }).map((_, index) => (
                        <CardSkeleton key={index} />
                    ))}
                </div>
            ) : items.length === 0 ? (
                <div className="text-sm text-muted-foreground" aria-live="polite">
                    {noResultsLabel}
                </div>
            ) : (
                <ComponentList items={items} gridClassName={SUBCATEGORY_PROVIDERS_GRID_CLASS} />
            )}
        </>
    );
};

export default SubCategoryProvidersContent;
